export class ChannelNameHelperService {
  public static getClassesChannelName(classId: string): string {
    return `Classes-${classId}`;
  }

  public static getGameShowForClassName(classId: string): string {
    return `ClassesGameShow-${classId}`
  }

  public static getGameShowForTeacherName(classId: string): string {
    return `TeacherClassesGameShow-${classId}`
  }
}
